import type { AxiosResponse } from 'axios';

import { airOptionAdapter } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/Event/ModalContents/Edit/TripEventModalContents/Flight/FlightTabs/Tabs/FlightApi/useFlightApi';

import { SNACKBAR_SKIN } from '../../components/shared/Snackbar';
import { IAirline, IAirport } from '../../detailsv2/structure';
import { showSnackbar } from '../../hooks/useSnackbar';
import axios from '../../utils/axios';
import { axiosGetAutoCancelDecorator } from '../../utils/axiosGetAutoCancelDecorator';
import { camelizeKeys } from '../../utils/humps';
import { getAccountId } from '../auth';

export const fakeApiFlightData = camelizeKeys([
  {
    airline: {
      active: true,
      fsCode: 'TEST',
      id: 464,
      name: 'TEST',
    },
    arrival_airport: {
      active: true,
      city: 'Minsk',
      cityCode: 'MSQ',
      countryName: 'Belarus',
      fsCode: 'MSQ',
      id: 10705,
      name: 'Minsk National Airport',
      utcOffsetHours: '3.0',
    },
    arrival_time: '2023-01-20T21:30:00.000',
    departureAirport: {
      active: true,
      city: 'Istanbul',
      cityCode: '1234',
      countryName: 'Turkiye',
      fsCode: 'ISL',
      id: 7530,
      name: 'Istanbul Airport',
      utcOffsetHours: '3.0',
    },
    departure_time: '2023-01-20T15:50:00.000',
    flight_number: '12345678',
  },
  {
    airline: {
      active: true,
      fsCode: 'B2',
      id: 441241,
      name: 'Belavia',
    },
    arrivalAirport: {
      active: true,
      city: 'Minsk',
      cityCode: 'MSQ',
      countryName: 'Belarus',
      fsCode: 'MSQ',
      id: 10705,
      name: 'Minsk National Airport',
      utcOffsetHours: '3.0',
    },
    arrival_time: '2023-01-20T21:30:00.000',
    departure_airport: {
      active: true,
      city: 'Istanbul',
      cityCode: '1234',
      countryName: 'Turkiye',
      fsCode: 'ISL',
      id: 7530,
      name: 'Istanbul Airport',
      utcOffsetHours: '3.0',
    },
    departure_time: '2023-01-20T15:50:00.000',
    flight_number: '781236',
  },
]);

const decoratedAxiosGet = axiosGetAutoCancelDecorator();

export const getAirOptionsLoader =
  <T extends 'airlines' | 'airports'>(createOption: typeof airOptionAdapter, type: T) =>
  async (query: string) => {
    if (query.length < 2) return;
    const accountId = getAccountId();
    const queryString = query ? `?q=${query}` : '';
    const response: AxiosResponse<{
      data: T extends 'airlines' ? IAirline[] : IAirport[];
    }> = await decoratedAxiosGet(`/acc/${accountId}/air_data/${type}${queryString}`);

    return response.data.data.map((page) => {
      return createOption(page, type == 'airports');
    });
  };

export const getScheduledFlightsByFlightNumber = async (
  fsCode: string,
  flightNumber: string,
  departureDate: string,
  setLoading: (value: boolean) => void,
) => {
  const accountId = getAccountId();
  const data = await axios
    .get(
      // eslint-disable-next-line max-len
      `/acc/${accountId}/air_data/scheduled_flights_by_flight_number?airline_fs_code=${fsCode}&flight_number=${flightNumber}&departure_date=${departureDate}`,
    )
    .then(({ data = {} }) => data)
    .catch((err) => {
      //@ts-ignore
      showSnackbar({ text: 'Something went wrong. Please try again.', type: SNACKBAR_SKIN.ERROR });
      throw err;
    })
    .finally(() => setLoading(false));

  return data;
};

export const getScheduledFlightsByRoute = async (
  departureAirportFsCode: string,
  arrivalAirportFsCode: string,
  departureDate: string,
  setLoading: (value: boolean) => void,
) => {
  const accountId = getAccountId();
  const data = await axios
    .get(
      // eslint-disable-next-line max-len
      `/acc/${accountId}/air_data/scheduled_flights_by_route?departure_airport_fs_code=${departureAirportFsCode}&arrival_airport_fs_code=${arrivalAirportFsCode}&departure_date=${departureDate}`,
    )
    .then(({ data = {} }) => data)
    .catch((err) => {
      //@ts-ignore
      showSnackbar({ text: 'Something went wrong. Please try again.', type: SNACKBAR_SKIN.ERROR });
      throw err;
    })
    .finally(() => setLoading(false));
  return data;
};
